var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 70,
  height: 70
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3472",
  transform: "translate(-54 -2394.14)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 35,
  fill: "#ebebeb",
  transform: "translate(54 2394.14)"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#0e2240",
  stroke: "#0e2240",
  strokeWidth: 0.3,
  "data-name": "Group 1736"
}, /*#__PURE__*/React.createElement("path", {
  d: "m105.65 2419.565-16.325-9.425-16.323 9.424v18.853l16.323 9.423 16.325-9.424zm-1.417 18.032-14.907 8.606v-6.023l-9.691-5.594v-11.19l4.887 2.821 4.8-2.773 4.8 2.773v5.547l-4.8 2.773v5.643l9.691-5.594v-11.19l-9.689-5.594-9.69 5.594-5.216-3.012 14.905-8.606 14.906 8.606Z",
  "data-name": "Path 3643"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.499 2428.457v2.818l2.441 1.409v-2.818z",
  "data-name": "Path 3644"
})))));
export { SvgNftIcon as ReactComponent };
export default "/_next/static/images/nft-icon.svg";